import { Modal, Form, Select, InputNumber, Input } from "antd";
import React, { useState } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";

// Manual credit adjustment: pick a user, +/- amount, reason.
const AdjustModal = ({ show, hide, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [searching, setSearching] = useState(false);

  let searchTimer = null;
  const onUserSearch = (value) => {
    if (searchTimer) clearTimeout(searchTimer);
    if (!value || value.length < 2) return;
    searchTimer = setTimeout(() => {
      setSearching(true);
      request({
        url: `${apiPath.listUser}?search=${value}&page=1&limit=20`,
        method: "GET",
        onSuccess: (data) => {
          setSearching(false);
          const docs = data?.data?.list?.docs || [];
          setUsers(
            docs.map((u) => ({
              value: u._id,
              label: `${u.name || "Unnamed"}${u.phone ? " — " + u.phone : ""}`,
            }))
          );
        },
        onError: () => setSearching(false),
      });
    }, 350);
  };

  const onSubmit = (values) => {
    setLoading(true);
    request({
      url: apiPath.adjustCredit,
      method: "POST",
      data: values,
      onSuccess: (d) => {
        setLoading(false);
        if (d.status) {
          ShowToast(d.message, Severty.SUCCESS);
          form.resetFields();
          hide();
          refresh();
        } else {
          ShowToast(d.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error.response?.data?.message || "Something went wrong", Severty.ERROR);
      },
    });
  };

  return (
    <Modal
      open={show}
      title="Adjust Credits"
      okText="Apply"
      onCancel={hide}
      okButtonProps={{ form: "adjust-credit", htmlType: "submit", loading }}
    >
      <Form id="adjust-credit" form={form} onFinish={onSubmit} layout="vertical">
        <Form.Item label="User" name="user_id" rules={[{ required: true, message: "Select a user" }]}>
          <Select
            showSearch
            placeholder="Search user by name or phone"
            filterOption={false}
            onSearch={onUserSearch}
            loading={searching}
            options={users}
            notFoundContent={searching ? "Searching..." : "Type to search"}
          />
        </Form.Item>
        <Form.Item
          label="Amount (use a negative value to deduct)"
          name="amount"
          rules={[{ required: true, message: "Enter an amount" }]}
        >
          <InputNumber style={{ width: "100%" }} placeholder="e.g. 10 or -5" />
        </Form.Item>
        <Form.Item label="Reason" name="reason" rules={[{ required: true, message: "Enter a reason" }]}>
          <Input.TextArea rows={3} placeholder="Reason for this adjustment" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AdjustModal;
